/*
 * RIDECLOUD WHY SUBSCRIBE SECTION
 * Style: Original RideCloud — white background, clean minimal layout
 * 4 benefit items with orange icons (matching original)
 * Comparison table: orange header, clean white rows
 * Colours: #2e004f headings, #e6531e accents, white bg
 */

import { BanknoteIcon, TrendingDown, RefreshCw, CheckSquare } from "lucide-react";

const benefits = [
  { icon: BanknoteIcon, label: "No balloon payments" },
  { icon: TrendingDown, label: "No long-term debt" },
  { icon: RefreshCw, label: "Upgrade when life changes" },
  { icon: CheckSquare, label: "One monthly fee" },
];

const comparisonRows = [
  {
    option: "Subscription (RideCloud)",
    icon: "🔔",
    commitment: "12–36 months",
    included: "Insurance, maintenance, roadside assist",
    bestFor: "All South African drivers",
    highlight: true,
  },
  {
    option: "Bank Finance",
    icon: "🏦",
    commitment: "5–6 years",
    included: "Vehicle only (insurance extra)",
    bestFor: "Long-term owners",
    highlight: false,
  },
  {
    option: "Short-Term Rental",
    icon: "🕐",
    commitment: "Daily / Weekly",
    included: "Insurance included, high daily rates",
    bestFor: "Short-term mobility needs",
    highlight: false,
  },
];

export default function WhySubscribe() {
  return (
    <section id="why-subscribe" className="py-16 md:py-20" style={{ backgroundColor: "#ffffff" }}>
      <div className="container">
        {/* Header */}
        <div className="mb-10">
          <h2
            className="text-3xl md:text-4xl font-semibold mb-2"
            style={{ color: "#2e004f" }}
          >
            Why Subscribe?
          </h2>
          <p className="text-base md:text-lg" style={{ color: "#5a3d70" }}>
            Flexible. Simple. Designed around your life.
          </p>
        </div>

        {/* Benefits grid — 2 columns matching original */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-4 gap-x-8 mb-12">
          {benefits.map((b) => {
            const Icon = b.icon;
            return (
              <div key={b.label} className="flex items-center gap-3">
                <Icon className="w-5 h-5 flex-shrink-0" style={{ color: "#e6531e" }} />
                <span className="text-base font-medium" style={{ color: "#2e004f" }}>
                  {b.label}
                </span>
              </div>
            );
          })}
        </div>

        {/* Comparison table */}
        <div>
          <p
            className="text-sm font-semibold mb-4 text-center"
            style={{ color: "#e6531e" }}
          >
            How Car Subscription Compares
          </p>
          <div
            className="overflow-x-auto rounded-lg border"
            style={{ borderColor: "rgba(46,0,79,0.15)" }}
          >
            <table className="w-full text-sm border-collapse">
              <thead>
                <tr style={{ backgroundColor: "#f8f7fa" }}>
                  {["Option", "Commitment", "What's Included", "Best For"].map((h, i) => (
                    <th
                      key={h}
                      className={`text-left px-5 py-3 font-semibold border-b ${i >= 2 ? "hidden md:table-cell" : ""} ${i === 3 ? "hidden lg:table-cell" : ""}`}
                      style={{ color: "#2e004f", borderColor: "rgba(46,0,79,0.10)" }}
                    >
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {comparisonRows.map((row, i) => (
                  <tr
                    key={row.option}
                    style={{
                      backgroundColor: row.highlight ? "rgba(46,0,79,0.03)" : "#ffffff",
                      borderBottom: i < comparisonRows.length - 1 ? "1px solid rgba(46,0,79,0.08)" : "none",
                    }}
                  >
                    <td className="px-5 py-3.5 font-medium" style={{ color: "#2e004f" }}>
                      <span className="mr-2">{row.icon}</span>
                      {row.option}
                    </td>
                    <td className="px-5 py-3.5" style={{ color: "#4a3060" }}>
                      {row.commitment}
                    </td>
                    <td className="px-5 py-3.5 hidden md:table-cell" style={{ color: "#4a3060" }}>
                      {row.included}
                    </td>
                    <td className="px-5 py-3.5 hidden lg:table-cell" style={{ color: "#4a3060" }}>
                      {row.bestFor}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}
